import { useState } from 'react';
import ReactHowler from 'react-howler';
import { Box, makeStyles } from '@material-ui/core';
import VolumeOffIcon from '@material-ui/icons/VolumeOff';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';

import backgroundSound from '../../../assets/audio/background.mp3';
import clickSound from '../../../assets/audio/clickEffect.mp3';

const useStyles = makeStyles((theme) => ({
  start: {
    position: 'absolute',
    background: theme.palette.background.default,
    minWidth: '60px',
    minHeight: '60px',
    zIndex: 200,
    borderRadius: '50%',
    top: '3%',
    right: '2%',
    '&:hover': {
      background: theme.palette.background.secondary,
    },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
}));
function SoundButton() {
  const classes = useStyles();
  const [sound, setSound] = useState(false);
  const [click, setClick] = useState(false);
  const handleActivate = () => {
    setSound(false);
  };
  const handleDisabled = () => {
    setClick(true);
    setSound(true);
  };
  const printButton = () => (
    <div>
      <Box className={classes.start} onPointerLeave={() => setClick(false)}>
        { !sound ? (
          <Box>
            <VolumeOffIcon
              onClick={handleDisabled}
            />
          </Box>
        ) : (
          <Box>
            <VolumeUpIcon
              onClick={handleActivate}
            />
          </Box>
        )}
      </Box>
    </div>
  );
  return (
    <div>
      <ReactHowler src={clickSound} playing={click} />
      <ReactHowler src={backgroundSound} playing={sound} loop />
      { printButton() }
    </div>
  );
}

export default SoundButton;
